export default __webpack_public_path__ + "static/media/woman.f4c34150.jpg";